import { useEffect } from 'react'

const CRISP_WEBSITE_ID = '614d82b0-f0a1-4eac-88f8-1868fb6326f3'

declare global {
  interface Window {
    $crisp: unknown[]
    CRISP_WEBSITE_ID: string
  }
}

export function CrispChat() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    window.$crisp = []
    window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID

    if (document.querySelector('script[src="https://client.crisp.chat/l.js"]')) return

    const script = document.createElement('script')
    script.src = 'https://client.crisp.chat/l.js'
    script.async = true
    document.head.appendChild(script)
  }, [])

  return null
}
